<template>
  <div>
    <div v-show="!roomBookVisible">
      <argumentLinkTable :operateColumns="operateColumns" ref="argumentTable">
      <Button slot="extraBtn" style="margin-left:10px;" type="success" @click="newArgument">新增</Button>
      </argumentLinkTable>
      <!-- 论证表单 -->
      <Modal title="论证信息" v-model="argumentFormVisible" :mask-closable="false" width="600">
        <argumentForm ref="argumentForm" @createSuccess="createSuccess" :editArgument="editArgument"></argumentForm>
        <div slot="footer">
          <Button @click="argumentFormVisible=false">取消</Button>
          <Button @click="createArgument" type="primary">确定</Button>
        </div>
      </Modal>
    </div>
    <div v-show="roomBookVisible">
      <!-- 会议室预约 -->
      <!-- <Modal title="会议室预约" v-model="roomBookVisible" width="98%" class-name="room-book"> -->
        <roomIndex @back="roomEmit" :argumentData="argumentData"></roomIndex>
      <!-- </Modal> -->
    </div>
  </div>
</template>

<script>
import ArgumentLinkTable from '@/components/argumentLinkTable'
import ArgumentForm from './argumentForm'
import RoomIndex from '@/views/room/roomIndex'
import ajax from '@/lib/ajax';

export default {
  name: 'argumentLink',
  components: {
    ArgumentLinkTable,
    ArgumentForm,
    RoomIndex
  },
  data() {
    return {
      roomBookVisible: false,
      argumentFormVisible: false,
      operateColumns: [
        {
          title: '操作',
          width: 160,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.editArgument = params.row
                    this.argumentFormVisible = true
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: async () => {
                    if(params.row.clMeetingRoomExt){
                      let rep = await ajax.get('/api/services/app/ClMeetingRoom/GetRoomList', {//获取该预约会议室id
			                	params:{
			                		filter: 'ClMeetingRoomExt.argumentid==' + params.row.clMeetingRoomExt.argumentId
			                	}
			                })
			                if(rep.data.result.items.length>0){
			                	var temp = params.row
			                	params.row = {
			                		argumentFull: temp.argumentFull,
			                		argumentName: temp.argumentName,
			                		argumentType: temp.argumentType,
			                		...rep.data.result.items[0]
			                	}
			                }
                    }else{
                      params.row.clMeetingRoomExt = {
                        id: 0
                      }
                    }
                    this.argumentData = params.row
                    this.roomBookVisible = true
                  }
                }
              }, '会议室预约')
            ])
          }
        }
      ],
      editArgument: '',
      argumentData:{
        id: 0
      }
    }
  },
  methods: {
    createSuccess() {
      this.argumentFormVisible = false
      this.$refs.argumentTable.refresh()
    },
    newArgument() {
      this.$refs.argumentForm.clearFormData()
      this.editArgument = ''
      this.argumentFormVisible = true
    },
    createArgument(){
      this.$refs.argumentForm.createOrUpdate()
    },
    roomEmit(){
      this.roomBookVisible = false;
      this.$refs.argumentTable.refresh()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.room-book {
  .ivu-modal {
    top: 10px;
  }
}
</style>
